import { memo, useState } from 'react';
import {
    GridRenderCellParams as IMuiGridRenderCellParams,
} from '@mui/x-data-grid-pro';
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DropdownMenu } from '@tap/mui-ui';

/**
 * Ячейка Номер заказа + Статус (опционально)
 */

type ActionsCellProps = {
    cellParams: IMuiGridRenderCellParams<any, any, any>,
    handleActionClick: (actionCode: ActionTypeCode, payload: any) => void,
}

export enum ActionTypeCode {
    Edit,
    CreateTechIssue,
    Delete,
}

export const ActionsCell = memo(({
    cellParams,
    handleActionClick,
}: ActionsCellProps) => {

    const [dropdownMenuAnchorEl, setDropdownMenuAnchorEl] = useState<null | HTMLElement>(null);

    if (cellParams.row.isVirtualRow) {
        return <></>;
    }

    return (
        <>
            <IconButton
                sx={{ padding: '2px', marginLeft: '10px' }}
                onClick={e => setDropdownMenuAnchorEl(e.currentTarget)}
            >
                <MoreVertIcon sx={{ color: '#666666', fontSize: '24px' }} />
            </IconButton>

            {/* Выпадающее меню */}
            <DropdownMenu
                id={`tableToolbar-dropdown-menu-${cellParams.row.id}`}
                anchorEl={dropdownMenuAnchorEl}
                open={!!dropdownMenuAnchorEl}
                onClose={() => setDropdownMenuAnchorEl(null)}
                menuItems={[
                    {
                        label: 'Изменить',
                        onClick: () => handleActionClick(ActionTypeCode.Edit, { row: cellParams.row }),
                    },
                    {
                        label: 'Создать заявку',
                        onClick: () => handleActionClick(ActionTypeCode.CreateTechIssue, { row: cellParams.row }),
                    },
                    {
                        label: 'Удалить',
                        onClick: () => handleActionClick(ActionTypeCode.Delete, { rowId: cellParams.row.id }),
                    },
                ]}
            />
        </>
    );
},
(prevProps, nextProps) => {
    return prevProps.cellParams === nextProps.cellParams;
},
);